// extracted by mini-css-extract-plugin
export default {"Disclaimer":"Swg0SPiep4"};